let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bqAzS")).then(() => parcelRequire('gYv97'));